import { motion } from "framer-motion";
import { FaGraduationCap, FaExclamationTriangle, FaUserShield, FaCopyright, FaGavel } from "react-icons/fa";
import "../styles/about.css";

// Moroccan geometric corner pattern SVG
const MoroccanCorner = ({ position = "top-left" }) => (
  <svg
    className={`moroccan-corner ${position}`}
    viewBox="0 0 200 200"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="goldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#D4AF37" stopOpacity="0.6" />
        <stop offset="100%" stopColor="#B8860B" stopOpacity="0.3" />
      </linearGradient>
    </defs>
    <g fill="none" stroke="url(#goldGradient)" strokeWidth="1.5">
      <polygon points="100,10 190,100 100,190 10,100" />
      <polygon points="100,30 170,100 100,170 30,100" />
      <polygon points="100,50 150,100 100,150 50,100" />
      <circle cx="100" cy="100" r="20" />
      <line x1="100" y1="10" x2="100" y2="80" />
      <line x1="100" y1="120" x2="100" y2="190" />
      <line x1="10" y1="100" x2="80" y2="100" />
      <line x1="120" y1="100" x2="190" y2="100" />
    </g>
  </svg>
);

// Decorative star/flower icon
const GoldStar = () => (
  <svg className="gold-star" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <g fill="#D4AF37">
      <polygon points="20,2 23,15 36,15 25,23 29,36 20,28 11,36 15,23 4,15 17,15" />
    </g>
  </svg>
);

function Terms() {
  return (
    <div className="about-page">
      <MoroccanCorner position="top-left" />
      <MoroccanCorner position="top-right" />

      <section className="hero-section">
        <h1 className="hero-title">Conditions Générales d'Utilisation</h1>
        <p className="hero-subtitle">
          CGU — Plateforme Académique
        </p>
        <GoldStar />
      </section>

      <section className="values-section">
        <h2 className="section-title">Points Clés</h2>
        <div className="values-grid">
          <motion.div
            className="value-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.1 }}
          >
            <div className="value-icon">
              <FaGraduationCap size={32} color="#D4AF37" />
            </div>
            <h3>Usage Pédagogique</h3>
            <p style={{ fontSize: "0.9rem", color: "var(--muted-foreground)", marginTop: "0.5rem" }}>
              Plateforme académique uniquement
            </p>
          </motion.div>

          <motion.div
            className="value-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.2 }}
          >
            <div className="value-icon">
              <FaExclamationTriangle size={32} color="#D4AF37" />
            </div>
            <h3>Limitation</h3>
            <p style={{ fontSize: "0.9rem", color: "var(--muted-foreground)", marginTop: "0.5rem" }}>
              Fourni "en l'état"
            </p>
          </motion.div>

          <motion.div
            className="value-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.3 }}
          >
            <div className="value-icon">
              <FaUserShield size={32} color="#D4AF37" />
            </div>
            <h3>Responsabilité</h3>
            <p style={{ fontSize: "0.9rem", color: "var(--muted-foreground)", marginTop: "0.5rem" }}>
              Sécurité de votre compte
            </p>
          </motion.div>

          <motion.div
            className="value-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.4 }}
          >
            <div className="value-icon">
              <FaCopyright size={32} color="#D4AF37" />
            </div>
            <h3>Propriété</h3>
            <p style={{ fontSize: "0.9rem", color: "var(--muted-foreground)", marginTop: "0.5rem" }}>
              Droits d'auteur protégés
            </p>
          </motion.div>

          <motion.div
            className="value-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.5 }}
          >
            <div className="value-icon">
              <FaGavel size={32} color="#D4AF37" />
            </div>
            <h3>Juridiction</h3>
            <p style={{ fontSize: "0.9rem", color: "var(--muted-foreground)", marginTop: "0.5rem" }}>
              Lois du Royaume du Maroc
            </p>
          </motion.div>
        </div>
      </section>

      <section className="mission-section">
        <div className="mission-card">
          <div className="mission-text">
            <h2>1. Usage Pédagogique et Non Commercial</h2>
            <p>
              Cette plateforme est un <strong>outil académique</strong> créé dans le cadre d'une thèse de doctorat. 
              Tous les modèles BIM et documents sont fournis exclusivement à des fins d'étude et de simulation.
            </p>
            <p>
              <strong>Toute utilisation commerciale de ces modèles est strictement interdite.</strong>
            </p>
          </div>
        </div>
      </section>

      <section className="mission-section">
        <div className="mission-card">
          <div className="mission-text">
            <h2>2. Limitation de Responsabilité ("En l'état")</h2>
            <p>
              Les modèles BIM sont fournis <strong>« tels quels »</strong>. Ni l'équipe de développement, ni la chercheuse principale (l'enseignante) 
              ne pourront être tenus responsables des erreurs structurelles, techniques ou financières résultant de l'application réelle de ces fichiers.
            </p>
            <p>
              <strong>Ceci n'est pas un service d'ingénierie professionnelle.</strong>
            </p>
          </div>
        </div>
      </section>

      <section className="mission-section">
        <div className="mission-card">
          <div className="mission-text">
            <h2>3. Responsabilité du Compte</h2>
            <p>
              L'accès est accordé via l'authentification Google. Les utilisateurs sont responsables de la sécurité de leur propre compte Google.
            </p>
            <p>
              Nous nous réservons le droit de révoquer l'accès à tout UID identifié comme tentant d'extraire des données de manière abusive (scraping) 
              ou violant les limites de bande passante.
            </p>
          </div>
        </div>
      </section>

      <section className="mission-section">
        <div className="mission-card">
          <div className="mission-text">
            <h2>4. Propriété Intellectuelle</h2>
            <p>
              Les modèles BIM sont la propriété de la chercheuse principale, sauf mention contraire précisant qu'ils sont en <strong>"Open Source"</strong>.
            </p>
            <p>
              <strong>Vous ne pouvez pas :</strong> redistribuer, vendre ou revendiquer la propriété des actifs téléchargés sur cette plateforme.
            </p>
          </div>
        </div>
      </section>

      <section className="mission-section">
        <div className="mission-card">
          <div className="mission-text">
            <h2>5. Juridiction</h2>
            <p>
              Ces conditions sont régies par les <strong>lois en vigueur au Royaume du Maroc</strong>, notamment en ce qui concerne 
              la protection des données personnelles et la propriété intellectuelle.
            </p>
          </div>
        </div>
      </section>

      <section className="contact-section">
        <div className="contact-card">
          <h2>Questions sur les CGU ?</h2>
          <p style={{ marginBottom: "1rem", color: "var(--muted-foreground)" }}>
            Pour toute question concernant ces conditions d'utilisation, veuillez nous contacter :
          </p>
          <p>
            <strong>Email :</strong>{" "}
            <a 
              href="mailto:contact@moroccandesignbim.com" 
              style={{ color: "var(--accent)", textDecoration: "underline" }}
            >
              contact@moroccandesignbim.com
            </a>
          </p>
        </div>
      </section>
    </div>
  );
}

export default Terms;
